/**
 * RTMP API service for cloud frontend.
 * All calls go through:
 * /api/nodes/:nodeId/cameras/:cameraId/rtmp/...
 */

import axios from 'axios';

const API_BASE = window.location.origin + '/api';

const api = axios.create({
  baseURL: API_BASE,
  timeout: 35000,
  headers: { 'Content-Type': 'application/json' },
});

// Attach auth token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('cloud_token');

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

// Handle auth/session expiry
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('cloud_token');

      if (!window.location.pathname.startsWith('/login')) {
        window.location.href = '/login';
      }
    }

    return Promise.reject(err);
  }
);

function base(nodeId: string, cameraId: string): string {
  return `/nodes/${nodeId}/cameras/${cameraId}/rtmp`;
}

// Register RTMP camera
export async function registerCamera(
  nodeId: string,
  cameraId: string,
  creds: {
    ip: string;
    port: number;
    username: string;
    password: string;
  }
) {
  const resp = await api.post(
    `${base(nodeId, cameraId)}/register`,
    creds
  );

  return resp.data;
}

// Get RTMP config
export async function getConfig(
  nodeId: string,
  cameraId: string
) {
  const resp = await api.get(
    `${base(nodeId, cameraId)}/config`
  );

  return resp.data;
}

// Update RTMP config
export async function updateConfig(
  nodeId: string,
  cameraId: string,
  config: any
) {
  const resp = await api.put(
    `${base(nodeId, cameraId)}/config`,
    { config }
  );

  return resp.data;
}